import { motion } from 'framer-motion';

const ReturnPolicy = () => {
    return (
        <section className='min-h-screen bg-surface-muted py-20 px-6'>
            <motion.div 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className='max-w-4xl mx-auto bg-white rounded-card shadow-premium p-10 lg:p-16'
            >
                <h1 className='text-4xl font-black text-primary mb-8 tracking-tight'>Return Policy</h1>
                <div className='prose prose-slate max-w-none space-y-8 text-gray-600 font-medium'>
                    <section>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>1. Returns</h2>
                        <p>We accept returns within 7 days of delivery. To be eligible for a return, your item must be unused, in the same condition that you received it, and in its original packaging.</p>
                    </section>

                    <section>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>2. Refunds</h2>
                        <p>Once we receive and inspect your return, we will notify you of the approval or rejection of your refund. If approved, your refund will be processed, and a credit will automatically be applied to your original method of payment.</p>
                    </section>

                    <section>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>3. Shipping & Delivery</h2>
                        <p>We aim to deliver all orders within 3-5 business days. Shipping costs are non-refundable. You will be responsible for paying for your own shipping costs for returning your item.</p>
                    </section>

                    <section className='pt-8 border-t border-surface-border'>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>4. Damaged Items</h2>
                        <p>If you receive a damaged or defective item, please contact us immediately at <strong>support@shalimarhelmet.com</strong> with your order number and a photo of the item.</p>
                    </section>
                </div>
            </motion.div>
        </section>
    );
};

export default ReturnPolicy;
